export default {
  'dashboard-analysis.analysis.test': '工專路 {no} 號店',
  'dashboard-analysis.analysis.introduce': '指標說明',
  'dashboard-analysis.analysis.total-sales': '總銷售額',
  'dashboard-analysis.analysis.day-sales': '日銷售額',
  'dashboard-analysis.analysis.visits': '訪問量',
  'dashboard-analysis.analysis.visits-trend': '訪問量趨勢',
  'dashboard-analysis.analysis.visits-ranking': '門店訪問量排名',
  'dashboard-analysis.analysis.day-visits': '日訪問量',
  'dashboard-analysis.analysis.week': '周同比',
  'dashboard-analysis.analysis.day': '日同比',
  'dashboard-analysis.analysis.payments': '支付筆數',
  'dashboard-analysis.analysis.conversion-rate': '轉化率',
  'dashboard-analysis.analysis.operational-effect': '運營活動效果',
  'dashboard-analysis.analysis.sales-trend': '銷售趨勢',
  'dashboard-analysis.analysis.sales-ranking': '門店銷售額排名',
  'dashboard-analysis.analysis.all-year': '全年',
  'dashboard-analysis.analysis.all-month': '本月',
  'dashboard-analysis.analysis.all-week': '本周',
  'dashboard-analysis.analysis.all-day': '今日',
  'dashboard-analysis.analysis.search-users': '搜索用戶數',
  'dashboard-analysis.analysis.per-capita-search': '人均搜索次數',
  'dashboard-analysis.analysis.online-top-search': '線上熱門搜索',
  'dashboard-analysis.analysis.the-proportion-of-sales': '銷售額類別占比',
  'dashboard-analysis.channel.all': '全部渠道',
  'dashboard-analysis.channel.online': '線上',
  'dashboard-analysis.channel.stores': '門店',
  'dashboard-analysis.analysis.sales': '銷售額',
  'dashboard-analysis.analysis.traffic': '客流量',
  'dashboard-analysis.table.rank': '排名',
  'dashboard-analysis.table.search-keyword': '搜索關鍵詞',
  'dashboard-analysis.table.users': '用戶數',
  'dashboard-analysis.table.weekly-range': '周漲幅',
};
